import { CategoryQuestions } from '../types';

export const celebrationQuestions: CategoryQuestions = {
  title: 'Personalize Your Celebration',
  questions: {
    preferredStyle: {
      label: 'What celebration style feels right to you?',
      type: 'radio',
      options: [
        'Uplifting and joyful',
        'Reflective and grateful',
        'Energetic and exciting',
        'Warm and appreciative'
      ]
    },
    primaryGoal: {
      label: 'What aspect would you like to focus on?',
      type: 'radio',
      options: [
        'Personal achievement and pride',
        'Gratitude and appreciation',
        'Joy and happiness amplification',
        'Sharing success with others',
        'Reflection on growth and journey'
      ]
    },
    celebrationType: {
      label: 'What are you celebrating?',
      type: 'select',
      options: [
        'Birthday or anniversary',
        'Career achievement or promotion',
        'Personal milestone or goal',
        'Graduation or educational achievement',
        'Relationship milestone',
        'Health recovery or fitness goal',
        'Creative accomplishment',
        'Life transition or new beginning',
        'Personal victory or breakthrough',
        'Special moment with loved ones'
      ]
    },
    celebrationFocus: {
      label: 'What energy would you like to bring to this celebration?',
      type: 'radio',
      options: [
        'Personal achievement and pride',
        'Gratitude and appreciation',
        'Joy and happiness amplification',
        'Sharing success with others',
        'Reflection on growth and journey'
      ]
    },
    energyLevel: {
      label: 'What energy level feels right for your celebration?',
      type: 'radio',
      options: [
        'Gentle appreciation and quiet joy',
        'Moderate celebration with warmth',
        'High-energy excitement and enthusiasm',
        'Mix of reflection and celebration'
      ]
    },
    specialPeople: {
      label: 'Who shares this celebration with you? (Optional)',
      type: 'textarea',
      placeholder: 'Family, friends, mentors, or anyone who supported your journey...'
    },
    specificFocus: {
      label: 'What specifically would you like to celebrate today?',
      type: 'textarea',
      placeholder: 'Describe your achievement, milestone, or special moment...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  // Practitioner perspective questions
  practitionerTitle: 'Personalize Celebration for Your Client',
  practitionerQuestions: {
    preferredStyle: {
      label: 'What celebration style feels right for your client?',
      type: 'radio',
      options: [
        'Uplifting and joyful',
        'Reflective and grateful',
        'Energetic and exciting',
        'Warm and appreciative'
      ]
    },
    primaryGoal: {
      label: 'What aspect should the celebration focus on?',
      type: 'radio',
      options: [
        'Personal achievement and pride',
        'Gratitude and appreciation',
        'Joy and happiness amplification',
        'Sharing success with others',
        'Reflection on growth and journey'
      ]
    },
    celebrationType: {
      label: 'What is your client celebrating?',
      type: 'select',
      options: [
        'Birthday or anniversary',
        'Career achievement or promotion',
        'Personal milestone or goal',
        'Graduation or educational achievement',
        'Relationship milestone',
        'Health recovery or fitness goal',
        'Creative accomplishment',
        'Life transition or new beginning',
        'Personal victory or breakthrough',
        'Special moment with loved ones'
      ]
    },
    celebrationFocus: {
      label: 'What energy should your client bring to this celebration?',
      type: 'radio',
      options: [
        'Personal achievement and pride',
        'Gratitude and appreciation',
        'Joy and happiness amplification',
        'Sharing success with others',
        'Reflection on growth and journey'
      ]
    },
    energyLevel: {
      label: 'What energy level would work best for your client?',
      type: 'radio',
      options: [
        'Gentle appreciation and quiet joy',
        'Moderate celebration with warmth',
        'High-energy excitement and enthusiasm',
        'Mix of reflection and celebration'
      ]
    },
    specialPeople: {
      label: 'Who shares this celebration with your client? (Optional)',
      type: 'textarea',
      placeholder: 'Family, friends, mentors, or anyone who supported their journey...'
    },
    specificFocus: {
      label: 'What specifically should your client celebrate?',
      type: 'textarea',
      placeholder: 'Describe their achievement, milestone, or special moment...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Personalize Celebration for Your Clients',
  practitionerGroupQuestions: {
    preferredStyle: {
      label: 'What celebration style feels right for your clients?',
      type: 'radio',
      options: [
        'Uplifting and joyful',
        'Reflective and grateful',
        'Energetic and exciting',
        'Warm and appreciative'
      ]
    },
    primaryGoal: {
      label: 'What aspect should your clients\' celebration focus on?',
      type: 'radio',
      options: [
        'Personal achievement and pride',
        'Gratitude and appreciation',
        'Joy and happiness amplification',
        'Sharing success with others',
        'Reflection on growth and journey'
      ]
    },
    celebrationType: {
      label: 'What are your clients celebrating?',
      type: 'select',
      options: [
        'Birthday or anniversary',
        'Career achievement or promotion',
        'Personal milestone or goal',
        'Graduation or educational achievement',
        'Relationship milestone',
        'Health recovery or fitness goal',
        'Creative accomplishment',
        'Life transition or new beginning',
        'Personal victory or breakthrough',
        'Special moment with loved ones'
      ]
    },
    celebrationFocus: {
      label: 'What energy should your clients bring to this celebration?',
      type: 'radio',
      options: [
        'Personal achievement and pride',
        'Gratitude and appreciation',
        'Joy and happiness amplification',
        'Sharing success with others',
        'Reflection on growth and journey'
      ]
    },
    energyLevel: {
      label: 'What energy level would work best for your clients?',
      type: 'radio',
      options: [
        'Gentle appreciation and quiet joy',
        'Moderate celebration with warmth',
        'High-energy excitement and enthusiasm',
        'Mix of reflection and celebration'
      ]
    },
    specialPeople: {
      label: 'Who shares this celebration with your clients? (Optional)',
      type: 'textarea',
      placeholder: 'Family, friends, mentors, or anyone who supported their journey...'
    },
    specificFocus: {
      label: 'What specifically should your clients celebrate?',
      type: 'textarea',
      placeholder: 'Describe their achievement, milestone, or special moment...'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  groupTitle: 'Personalize Your Group Celebration',
  groupQuestions: {
    preferredStyle: {
      label: 'What celebration style feels right for your group?',
      type: 'radio',
      options: [
        'Uplifting and joyful',
        'Reflective and grateful',
        'Energetic and exciting',
        'Warm and appreciative'
      ]
    },
    primaryGoal: {
      label: 'What is the group\'s shared celebration focus?',
      type: 'radio',
      options: [
        'Collective achievement and pride',
        'Shared gratitude and appreciation',
        'Joy and happiness together',
        'Celebrating each other\'s success',
        'Reflection on group growth'
      ]
    },
    celebrationType: {
      label: 'What is the group celebrating?',
      type: 'select',
      options: [
        'Shared achievement or milestone',
        'Team success or project completion',
        'Family celebration or anniversary',
        'Group accomplishment',
        'Community milestone',
        'Collective victory or breakthrough',
        'Multiple individual celebrations',
        'Special occasion or holiday'
      ]
    },
    celebrationStyle: {
      label: 'How should the group celebration be guided?',
      type: 'radio',
      options: [
        'Individual recognition within group unity',
        'Collective celebration and shared joy',
        'Interactive with group participation',
        'Reflective appreciation together'
      ]
    },
    sharedFocus: {
      label: 'What is the group\'s shared celebration focus?',
      type: 'textarea',
      placeholder: 'Describe what the group is celebrating together...'
    },
    energyLevel: {
      label: 'What energy level works best for the group?',
      type: 'radio',
      options: [
        'Gentle appreciation and quiet joy',
        'Moderate celebration with warmth',
        'High-energy group excitement',
        'Mix of reflection and celebration'
      ]
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  giftTitle: 'Personalize Celebration for Your Loved One',
  giftQuestions: {
    preferredStyle: {
      label: 'What celebration style feels right for them?',
      type: 'radio',
      options: ['Uplifting and joyful', 'Reflective and grateful', 'Energetic and exciting', 'Warm and appreciative']
    },
    celebrationType: {
      label: 'What are they celebrating?',
      type: 'select',
      options: ['Birthday or anniversary', 'Career achievement or promotion', 'Personal milestone or goal', 'Graduation or educational achievement', 'Relationship milestone', 'Health recovery or fitness goal', 'Creative accomplishment', 'Life transition or new beginning', 'Personal victory or breakthrough', 'Special moment with loved ones']
    },
    primaryGoal: {
      label: 'What aspect should the celebration focus on?',
      type: 'radio',
      options: ['Personal achievement and pride', 'Gratitude and appreciation', 'Joy and happiness amplification', 'Reflection on growth and journey']
    },
    specificFocus: {
      label: 'What specifically should they celebrate?',
      type: 'textarea',
      placeholder: 'Describe their achievement, milestone, or special moment...'
    },
    specialPeople: {
      label: 'Who shares this celebration with them? (Optional)',
      type: 'textarea',
      placeholder: 'Family, friends, mentors, or anyone who supported their journey...'
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect celebration for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  }
};